import styled from 'styled-components';


export const TabsCardWrap = styled.section`
  display: flex;
  flex-direction: column;
  border-top: 1px solid #eff3f8;
  padding: 1rem 2rem;
  width: 100%;
`;
